import { useEffect } from 'react';

const Home = () => {
  return (
    <div className="w-full flex justify-center py-12">
      <section className="w-full max-w-4xl mx-4 bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg border border-white/20">
        <div className="prose prose-lg text-gray-700 max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">Materia Medica</h1>
          
          <p className="mb-6">
            Materia Medica, Latin for "medical material," refers to the body of collected knowledge about the therapeutic properties of any substance used for healing. This ancient practice dates back to the 1st century AD when Greek physician Pedanius Dioscorides compiled his comprehensive work "De Materia Medica," which remained the authoritative text on herbal medicine for over 1,500 years.
          </p>
          
          <p className="mb-6">
            In modern herbalism, a Materia Medica is a reference work that documents the traditional and scientific knowledge of medicinal plants, including their:
          </p>
          
          <ul className="list-disc pl-6 mb-8 space-y-2">
            <li>Botanical characteristics and identification</li>
            <li>Historical and traditional uses</li>
            <li>Chemical constituents and active compounds</li>
            <li>Therapeutic properties and applications</li>
            <li>Preparation methods and dosages</li>
            <li>Safety considerations and contraindications</li>
          </ul>
          
          <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-400">
            <p className="text-blue-700 italic">
              "The art of healing comes from nature, not from the physician. Therefore the physician must start from nature, with an open mind."
              <span className="block mt-2 text-blue-600">— Paracelsus</span>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
